import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SiteViewPageContainer } from 'pages/overview/SiteViewPageContainer'

export const Route = createFileRoute('/overview/{-$siteID}')({
  component: OverviewRouteComponent,
  staticData: {
    title: 'Site Overview',
  },
})

function OverviewRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <SiteViewPageContainer />
}
